import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

type SearchNavSlotContextValue = {
  slot: HTMLDivElement | null;
  setSlot: (node: HTMLDivElement | null) => void;
};

const SearchNavSlotContext = createContext<SearchNavSlotContextValue | null>(null);

export function SearchNavSlotProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLDivElement | null>(null);
  const value = useMemo(() => ({ slot, setSlot }), [slot]);
  return <SearchNavSlotContext.Provider value={value}>{children}</SearchNavSlotContext.Provider>;
}

export function useSearchNavSlot() {
  return useContext(SearchNavSlotContext)?.slot ?? null;
}

export function useSetSearchNavSlot() {
  const setSlot = useContext(SearchNavSlotContext)?.setSlot;
  return setSlot ?? (() => undefined);
}
